/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A recent executive hire or departure.
 *
 * `person_id` is the vendor person id and is NOT a profile id; it is
 * included only so callers can correlate against other vendor payloads.
 */
export interface CompanyExecMoveSchema {
  person_id?: string | null;
  date?: string | null;
  job_title?: string | null;
  job_title_role?: string | null;
  counterparty_company_id?: string | null;
  counterparty_job_title?: string | null;
}
